/* global $ */

import localDb from '../helpers/localDb';

const STORAGE_KEY = 'site-alert';

export default {
  initialize() {
    this.element = $('.js-site-alert').get(0);
    this.close = $('.js-site-alert-close');

    if (!this.element) {
      return;
    }

    if (!('localStorage' in window)) {
      return;
    }

    if (!localDb.get(STORAGE_KEY)) {
      this.element.removeAttribute('hidden');
    }

    this.close.on('click', () => this.onClose());
  },

  onClose() {
    this.element.style.display = 'none';

    const ttlInHours = parseInt(this.element.dataset.closeTtl, 10);
    const millisecondsPerHour = 3600000;
    const ttlInMilliseconds = ttlInHours * millisecondsPerHour;

    localDb.set(STORAGE_KEY, 1, ttlInMilliseconds);
  },
};
